export default {}



// WEBPACK FOOTER //
// ./src/page/int/face/hikFaceEvent/lang/index.en.js